module.exports = __webpack_public_path__ + "img/download_google_store.bdb09c16.png";